import React from 'react';
import { getLastUserInfo } from 'js/library/utils/helpers';
import ShareItem from 'js/containers/Campaigns/ShareItem';
import { promos } from './promos';

export default function SharePromotions(props) {
  const userInfo = getLastUserInfo();
  const uId = !userInfo.isAnonymous ? userInfo.uId : 'anonymous';

  return (
    <div style={{ marginTop: 10 }}>
      {promos.map((promo) => {
        return (
          <ShareItem
            setOpenState={props.setOpenState}
            key={promo.idPromo}
            idPromo={promo.idPromo}
            imagePromo={promo.imagePromo}
            titlePromo={promo.titlePromo}
            descriptionPromo={promo.descriptionPromo}
            textShare={promo.textShare}
            uId={uId}
          />
        );
      })}
    </div>
  );
}
